import React from 'react';

import PropTypes from 'prop-types';

import { InputGroup, Input } from './styles';

function InputSearch(props) {
  const { data, keys, visible, setList } = props;

  const handleChange = (e) => {
    const { value } = e.target;
    let filteredData = [];

    if (keys) {
      filteredData = data.filter((item) => {
        return keys.some((key) => String(item[key]).toLowerCase().includes(value.toLowerCase()));
      });
    } else {
      filteredData = data.filter((item) =>
        String(item).toLowerCase().includes(value.toLowerCase())
      );
    }

    setList(filteredData);
  };

  if (visible) {
    return (
      <InputGroup>
        <Input {...props} onChange={handleChange} />
      </InputGroup>
    );
  }
  return null;
}

InputSearch.defaultProps = {
  keys: null,
  visible: true,
};

InputSearch.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object, PropTypes.string).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string),
  visible: PropTypes.bool,
  setList: PropTypes.func.isRequired,
};

export default InputSearch;
